import React from "react";
import { InboxCard } from "../orgnims/InboxCard";
// import TimeStamp from "../orgnims/TimeStamp"; // 👈 commented out for now

export const Inbox = () => {
  return (
    <div className="flex flex-row justify-between w-full min-h-screen gap-6 px-4 py-6 bg-[#F6F7F9]">
      <div className="w-2/3 h-full">
        <InboxCard />
      </div>
      <div className="w-1/3 h-full">
        {/* <TimeStamp /> 👈 hidden for now */}
      </div>
    </div>
  );
};
